import $ from "jquery";
import Cookies from "js-cookie";
import objectFitImages from "object-fit-images";
import svg4everybody from "svg4everybody";
import "jquery-validation";
import "jquery-validation-unobtrusive";
import "lazysizes";
import "picturefill";
import "responsive-bp/build/responsive.js";
import "slick-carousel";
import "jquery-hoverintent";
import "@fancyapps/fancybox";

import uiHelpers from "./ui-helpers";

svg4everybody();
uiHelpers.init();
objectFitImages();

// include any plugin initialisation here
// any custom JS that needs to be written should be modular (and in a separate file), possibly done as a jQuery plugin or some other modular form, and initialised here like the other plugins
$(".no-js").removeClass("no-js");

// Send scrolling events to Google Analytics http://scrolldepth.parsnip.io/
if (typeof $.scrollDepth === "function") {
  $.scrollDepth();
}

// Navigation
addListernersToNav();

$(window).resize(() => {
  addListernersToNav();
});

function addListernersToNav() {
  const windowWidth = $(window).width();
  let currPageScrollPos: number | undefined = 0;
  // Unbind
  $(".js-menu-toggle").unbind("click");
  $(".js-nav-link").unbind("mouseover");
  $(".js-secondary-nav-link").unbind("mouseover");
  $(".js-nav-link").unbind("click");
  $(".js-secondary-nav-link").unbind("click");
  $(".js-nav-back").unbind("click");
  // Rebind
  $(".js-menu-toggle").on("click", (e) => {
    e.preventDefault();
    const thisEl = $(e.currentTarget);

    // $("body").toggleClass("menu-open");

    // Set aria on toggle
    if ($("body").hasClass("menu-open")) {
      thisEl
        .attr("aria-label", "Show navigation")
        .attr("aria-expanded", "false");
    } else {
      thisEl
        .attr("aria-label", "Hide navigation")
        .attr("aria-expanded", "true");

      currPageScrollPos = $(window).scrollTop();
    }
    $("body").toggleClass("menu-open");

    if (currPageScrollPos) {
      $(window).scrollTop(currPageScrollPos);
    }

    if (windowWidth && windowWidth <= 1023) {
      $(".js-secondary-nav").removeClass("primary-navigation__nav--open");
      $(".js-tertiary-nav").removeClass("primary-navigation__nav--open");
    } else {
      $(".js-secondary-nav").removeClass("primary-navigation__nav--open");
      $(".js-secondary-nav").first().addClass("primary-navigation__nav--open");
      $(".js-tertiary-nav").removeClass("primary-navigation__nav--open");
    }
  });
  if (windowWidth && windowWidth >= 1024) {
    $(".js-nav-link").hoverIntent({
      over() {
        const target = $(this).attr("data-target");

        $(".js-nav-link").removeClass(
          "primary-navigation__nav-link--has-secondary-tier-open",
        );
        $(this).addClass(
          "primary-navigation__nav-link--has-secondary-tier-open",
        );

        $(".js-nav-feature")
          .not("[data-id='" + target + "']")
          .removeClass("primary-navigation__feature--open");
        $(".js-nav-feature[data-id='" + target + "']").addClass(
          "primary-navigation__feature--open",
        );

        $(".js-secondary-nav")
          .not("[data-id='" + target + "']")
          .removeClass("primary-navigation__nav--open");
        $(".js-secondary-nav[data-id='" + target + "']").addClass(
          "primary-navigation__nav--open",
        );
        $(".js-tertiary-nav").removeClass("primary-navigation__nav--open");
      },
      out() {
        //
      },
    });

    $(".js-secondary-nav-link").hoverIntent({
      over() {
        const target = $(this).attr("data-target");

        $(".js-nav-link").removeClass(
          "primary-navigation__nav-link--has-tertiary-tier-open",
        );
        $(this).addClass(
          "primary-navigation__nav-link--has-tertiary-tier-open",
        );

        $(".js-tertiary-nav")
          .not("[data-id='" + target + "']")
          .removeClass("primary-navigation__nav--open");
        $(".js-tertiary-nav[data-id='" + target + "']").addClass(
          "primary-navigation__nav--open",
        );
        $(".js-nav-feature").removeClass("primary-navigation__feature--open");
      },
      out() {
        //
      },
    });
  }
  // top tier links
  $(".js-nav-link").on("click", function (event) {
    event.preventDefault();
    const target = $(this).attr("data-target");

    $(".js-secondary-nav")
      .not("[data-id='" + target + "']")
      .removeClass("primary-navigation__nav--open");
    $(".js-secondary-nav[data-id='" + target + "']").addClass(
      "primary-navigation__nav--open",
    );
  });
  // Sub tier links
  $(".js-secondary-nav-link").on("click", function (event) {
    event.preventDefault();
    const target = $(this).attr("data-target");

    $(".js-tertiary-nav")
      .not("[data-id='" + target + "']")
      .removeClass("primary-navigation__nav--open");
    $(".js-tertiary-nav[data-id='" + target + "']").addClass(
      "primary-navigation__nav--open",
    );
    $(".js-nav-feature").removeClass("primary-navigation__feature--open");
  });
  // Back button
  $(".js-nav-back").on("click", function (event) {
    event.preventDefault();
    const target = $(this).attr("data-target");

    $(".js-tertiary-nav").removeClass("primary-navigation__nav--open");
    $(".js-secondary-nav")
      .not("[data-id='" + target + "']")
      .removeClass("primary-navigation__nav--open");
    $(".js-secondary-nav[data-id='" + target + "']").addClass(
      "primary-navigation__nav--open",
    );
  });
}

// Search
$(".js-search-open").on("click", (e) => {
  $("body").toggleClass("no-scroll");
  $(".search__modal").toggleClass("is-visible");
  e.preventDefault();
});

$(".js-search-close").on("click", (e) => {
  $("body").removeClass("no-scroll");
  $(".search__modal").removeClass("is-visible");
  e.preventDefault();
});

$(document).keyup((e) => {
  if (e.keyCode === 27) {
    if ($(".search__modal").hasClass("is-visible")) {
      $("body").removeClass("no-scroll");
      $(".search__modal").removeClass("is-visible");
    }
  }
});

// Donation form
$(".donation-type").on("change", () => {
  showHideOptions();
  showHidePaymentOptions();
  $(".show-hide-target:visible:last").prop("checked", true);
});

$(".company-group").on("change", () => {
  showHideOrgInfo();
});

function showHideOrgInfo() {
  if ($("#StepTwo-CompanyOrGroup_True").is(":checked")) {
    $("#org-info").show();
  } else {
    $("#org-info").hide();
  }
}

function showHideOptions() {
  const donationTypeOption = $(".donation-type:checked").val();
  $.each($(".show-hide-target"), function () {
    if ($(this).data("show-for").indexOf(donationTypeOption) >= 0) {
      $(this).parent().show();
    } else {
      $(this).parent().hide();
    }
  });
}

function showHidePaymentOptions() {
  const donationTypeOption = $(".donation-type:checked").val();
  const paymentOptionsContainer = $(".js-payment-options");
  
  if (donationTypeOption === "Regular") {
    paymentOptionsContainer.show();
  } else {
    paymentOptionsContainer.hide();
  }
}

showHideOptions();
showHideOrgInfo();
showHidePaymentOptions();

// Donate panel
let donationType: string | undefined = "regular";
let donationAmount: string | undefined = undefined;

$(".js-donation-tab").on("click", (e) => {
  const thisEl = $(e.currentTarget);
  const parentEl = thisEl.parents(".donation-panel");

  parentEl.find(".js-donation-tab").removeClass("donation-panel__btn--active");
  thisEl.addClass("donation-panel__btn--active");
  parentEl
    .find(".js-donation-tab-content")
    .removeClass("donation-panel__tab-content--active");
  parentEl
    .find(".js-donation-tab-content[data-tab=" + thisEl.attr("data-tab") + "]")
    .addClass("donation-panel__tab-content--active");

  donationType = thisEl.attr("data-tab");
  donationAmount = undefined;
});

$(".js-donation-denomination").on("click", (e) => {
  const thisEl = $(e.currentTarget);
  const parentEl = thisEl.parents(".donation-panel__denominations");
  parentEl
    .find(".js-donation-denomination")
    .removeClass("donation-panel__btn--active");
  thisEl.addClass("donation-panel__btn--active");

  parentEl.find(".js-donation-amount").val("");

  donationAmount = thisEl.attr("data-amount") as string;
});

$(".js-donation-amount").on("keyup", (e) => {
  const thisEl = $(e.currentTarget);
  const parentEl = thisEl.parents(".donation-panel__denominations");

  if (thisEl.val() !== "") {
    parentEl
      .find(".js-donation-denomination")
      .removeClass("donation-panel__btn--active");
    donationAmount = thisEl.val() as string;
  }
});

$(".js-donation-submission").on("click", (e) => {
  const thisEl = $(e.currentTarget);
  const parentEl = thisEl
    .parents(".js-donation-tab-content")
    .find(".donation-panel__denominations");

  if (donationAmount === undefined || donationAmount === null) {
    if (parentEl.find(".donation-panel__btn--active").length) {
      donationAmount = parentEl
        .find(".donation-panel__btn--active")
        .attr("data-amount");
    } else {
      donationAmount = parentEl.find(".js-donation-amount").val() as string;
    }
  }
  const donateUrl =
    thisEl.attr("data-src") +
    "?type=" +
    donationType +
    "&amount=" +
    donationAmount;

  window.location.href = donateUrl;
});

// Slick
$(".js-carousel").slick({
  arrows: true,
  responsive: [
    {
      breakpoint: 600,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: "80px",
        slidesToScroll: 1,
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        slidesToScroll: 1,
        slidesToShow: 1,
      },
    },
  ],
  slidesToScroll: 1,
  slidesToShow: 3,
});

// Cookies
$(".js-legacy-cookie-accept").on("click", () => {
  Cookies.set("EtchCookieConsent", "true", {expires: 365});
});

if (!Cookies.get("EtchCookieConsent")) {
  $(".legacy-cookie-message").addClass("legacy-cookie-message--visible");
}

// Accordions
const acc = document.getElementsByClassName("js-accordion");

for (let i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function (this: Element) {
    const panel = this.nextElementSibling as HTMLElement | null;

    this.parentElement?.classList.toggle("active");

    if (panel) {
      if (panel.style.maxHeight) {
        panel.style.maxHeight = "";
      } else {
        panel.style.maxHeight = `${panel.scrollHeight}px`;
      }
    }
  });
}

// Tabbed content
$(".js-tab").on("click", function () {
  const index = $(this).index() + 1;
  const tabs = $(this).parent().next();

  $(this).addClass("active").siblings().removeClass("active");
  tabs.find("> div").removeClass("active");
  tabs.find("> div:nth-child(" + index + ")").addClass("active");
});

// Alert Bars
(() => {
  function rm(x: Element) {
    x.parentNode?.removeChild(x);
  }

  const b = document.querySelectorAll(".alert-bar");
  if (!b) {
    return;
  }

  b.forEach((el) => {
    const id = el.getAttribute("data-banner-id");

    if (!id) return;

    if (localStorage.getItem("banner-id") === id) {
      return rm(el);
    } else {
      el.classList.add("alert-bar--visible");
    }

    const c = el.querySelector(".js-alert-accept");
    if (c) {
      c.addEventListener("click", () => {
        localStorage.setItem("banner-id", id);
        rm(el);
      });
    }
  });
})();
